import React from "react";


export default function Portfolio() {
    return (
        <section className="portfolio">
            <div className="container grid-1 features">
            <FeatureCard
            img={require("../images/IMG_2634.jpg")}
            alt= "Pool wall"
            title="Walls & Fountain Installations"
            text="Pool wall"
            />
            </div>
        </section>
    );
}

function FeatureCard({ title, text, img, alt}) {
    return (
        <article className="card">
        <div className="card-body">
        <img className="card-img" src={img} alt={alt} />
        <h3>{title}</h3>
        <p>{text}</p>
        </div>
        </article>
    );
}